import { isEmpty } from 'lodash'
import { compose, withState, withHandlers } from 'recompose'
import numeral from 'numeral'

export const fetchingState = (options = {}) => {
  const { multi = false } = options

  return compose(
    withState('fetching', 'toggleFetching', multi ? {} : false),
    withHandlers({
      fetchingWrap: ({ toggleFetching }) => async (func, key) => {
        toggleFetching(data => multi ? { ...data, [key]: true } : true)
        let result = await func()
        toggleFetching(data => multi ? { ...data, [key]: false } : false)
        return result
      }
    })
  )
}

export const formState = compose(
  withState('data', 'changeData', {}),
  withState('errors', 'pushErrors', {}),
  withHandlers({
    clearData: ({ changeData }) => () => { changeData({}) },
    changeField: ({ changeData }) => (field, value) => changeData(data => ({ ...data, [field]: value })),
    verifyForm: ({ pushErrors, data }) => (fields, initial = {}) => {
      // let errors = Form.validate(data, fields, initial)
      let errors = {}
      pushErrors(errors)
      return isEmpty(errors)
    }
  })
)

//получение на сайте общей суммы, которую округляем до порядка grade
export const getApproximateTotalSum = (sum) => {
	const grade = 10000000
	const roundingFloor = (val) => Math.floor(val / grade) * 10
	let total = ''

	Object.keys(sum).map((key, i) => {
		let value = sum[key]
		if (!value) return null
		else {
		  /*if (value > grade) {
        value = roundingFloor(value)
		    total = `Более ${numeral(value).format('0,0')} млн ${key}`
      } else total = total + ((i > 0) ? ', ' : '') + numeral(value).format('0,0') + ' ' + key
      */
      total = total + ((i > 0) ? ', ' : '') + numeral(value).format('0,0') + ' ' + key
		}
		return null
	})
	return total
}

//функция для отправки данных в mindbox
export async function sendMindbox(data={}, action) {
	const clientIP = window.PopMechanic.ip
	let uuidArr = document.cookie.match(/mindboxDeviceUUID=[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}/)
	const UUID = (window.PopMechanic.customs && window.PopMechanic.customs.mindboxDeviceUUID) ? window.PopMechanic.customs.mindboxDeviceUUID : uuidArr[0].split('=')[1]

	const secretKey = '9k9SNpfIHYUBW8gi9yIG'
	const endpoint = 'meetforcharity-website' //точка интеграции
	let URL

	switch (action) {
		case 'registration':
			URL = `https://api.mindbox.ru/v3/operations/async?endpointId=${endpoint}&operation=Website.RegisterCustomer&deviceUUID=${UUID}`
			break
		case 'authorization':
			URL = `https://api.mindbox.ru/v3/operations/async?endpointId=${endpoint}&operation=Website.AuthorizeCustomer`
			break
		case 'authorization_2':
			URL = `https://api.mindbox.ru/v3/operations/async?endpointId=${endpoint}&operation=Website.RegisterCustomer&deviceUUID=${UUID}`
			break
		case 'edit':
			URL = `https://api.mindbox.ru/v3/operations/async?endpointId=${endpoint}&operation=Website.EditCustomer&deviceUUID=${UUID}`
			break
		case 'monitoring':
			URL = `https://api.mindbox.ru/v3/operations/async?endpointId=${endpoint}&operation=OtslezhivaenieAukciona&deviceUUID=${UUID}`
			break
		case 'demonitoring':
			URL = `https://api.mindbox.ru/v3/operations/async?endpointId=${endpoint}&operation=PrekrashhenieOtslezhivaniyaAukciona&deviceUUID=${UUID}`
			break
		case 'viewCategories':
			URL = `https://api.mindbox.ru/v3/operations/async?endpointId=${endpoint}&operation=Website.ViewCategory&deviceUUID=${UUID}`
			break
		case 'viewLot':
			URL = `https://api.mindbox.ru/v3/operations/async?endpointId=${endpoint}&operation=ProsmotrAukciona&deviceUUID=${UUID}`
			break
		case 'repeatVisit':
			URL = `https://api.mindbox.ru/v3/operations/async?endpointId=${endpoint}&operation=ZayavkaNaPovtornuyuVstrechu&deviceUUID=${UUID}`
			break
		case 'newBid':
			URL = `https://api.mindbox.ru/v3/operations/async?endpointId=${endpoint}&operation=Website.CreateAuthorizedOrder&deviceUUID=${UUID}`
			break
		case 'claim_autorized':
			URL = `https://api.mindbox.ru/v3/operations/async?endpointId=${endpoint}&operation=ZapolnenieAnketyStatUchastnikom`
			break
		case 'claim_notautorized':
			URL = `https://api.mindbox.ru/v3/operations/async?endpointId=${endpoint}&operation=AnketyStatUchastnikomNotAutorise&deviceUUID=${UUID}`
			break	
		case 'registrationFundNotAutorized':
			URL = `https://api.mindbox.ru/v3/operations/async?endpointId=${endpoint}&operation=AnketaPodklyuchenieFondaNotAutorise&deviceUUID=${UUID}`
			break
		case 'registrationFundAutorized':
			URL = `https://api.mindbox.ru/v3/operations/async?endpointId=${endpoint}&operation=AnketaDlyaPodklyucheniyaFonda`
			break	
		case 'donation':
			URL = `https://api.mindbox.ru/v3/operations/async?endpointId=${endpoint}&operation=Website.UpdateOrderStatus`
			break
		default:
			console.log('not set URL for request*************')
			return
	}

	try {
		const response = await fetch(URL, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8',
				'Accept': 'application/json',
				'Authorization': `Mindbox secretKey="${secretKey}"`,
				'User-Agent': window.navigator.userAgent,
				'X-Customer-IP': clientIP
			},
			body: JSON.stringify(data)
		});

		if (response.ok) {
			const responseData = await response.json();
			console.log(`данные по ${action} успешно отправлены в mindbox, ответ:`, responseData)
		} else {
			console.log(`Ошибка запроса в mindbox, действие: ${action}, статус: ${response.status}`);
		}
	} catch (err) {
		console.log('Ошибка в работе функции:', err)
  	}

}


// WEBPACK FOOTER //
// ./src/helpers/hocs.js